<template>
    <div class="step-layout seven">
        <!-- ---------------------------- Step Intro Section ---------------------------- -->
        <section class="step-layout-left bg-7">
            <div class="step-layout-container">
                <h2 class="text-white intro-title d-none d-sm-block">
                    We are using artificial intelligence with AVM (Automated
                    Valuation Method) to find the home value.
                </h2>
                <h2 class="text-white intro-title d-block d-sm-none text-center">
                    We are using artificial intelligence with AVM (Automated
                    Valuation Method) to find the home value
                </h2>
                <!-- Back Button -->
                <div class="text-center text-sm-left">
                    <a href="javascript:void(0)" v-on:click="goBack()" class="button_layout">
                        <i class="fa-solid fa-circle-arrow-left mr-2"></i>BACK
                    </a>
                </div>
            </div>
        </section>
        <!-- -------------------------- Step Form Section -------------------------- -->
        <section class="step-layout-right">
            <div class="step-layout-container pb-2">
                <h2 class="heading_section title">
                    These questions help us provide a better home value.
                </h2>
                <form class="text-center home-details-form" action="#" @submit.prevent="submitForm">
                    <div class="form-group">
                        <input type="hidden" v-model="street_address" />
                        <vue-google-autocomplete id="map" ref="mapElement" class="form-control autocomplete"
                            placeholder="Enter your home address*" :country="['ca']" @placechanged="getAddressData"
                            :value="street_address"></vue-google-autocomplete>
                        <small v-if="showError && !street_address" class="text-danger d-block text-left mt-3">
                            <b>* Address is required</b>
                        </small>
                    </div>
                    <!-- Type Of Home -->
                    <div class="form-group list-select" :class="showError && !propertyType ? 'border-danger' : ''">
                        <select class="form-control selectpicker" v-model="propertyType">
                            <option value="" :disabled="true">Type of Home</option>
                            <option value="Detached">Detached Home</option>
                            <option value="Semi-Detached">Semi-Detached</option>
                            <option value="Att/Row/Twnhouse">Att/Row/Townhouse</option>
                            <option value="Condo Townhouse">Condo Townhouse</option>
                            <option value="Condo Apt">Condo Apartment</option>
                            <option value="Other">Other</option>
                        </select>
                        <small v-if="showError && !propertyType" class="text-danger d-block text-left mt-3">
                            <b>* Type of Home is required</b>
                        </small>
                    </div>

                    <!-- Style of home -->
                    <div class="form-group list-select">
                        <select class="form-control selectpicker" v-model="home_style">
                            <option value="" :disabled="true">Style of home</option>
                            <option value="2-story">2 Story</option>
                            <option value="3-story">3 Story</option>
                            <option value="Bungalow">Bungalow</option>
                            <option value="Back split">Back split</option>
                            <option value="Side split">Side split</option>
                            <option value="Other">Other</option>
                        </select>
                    </div>

                    <!-- Bedrooms Select -->
                    <div class="form-group grid-select" :class="showError && !bedrooms ? 'border-danger' : ''">
                        <select class="form-control selectpicker" v-model="bedrooms">
                            <option value="" :disabled="true">Bedroom (Above ground)</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6+">6+</option>
                        </select>
                        <small v-if="showError && !bedrooms" class="text-danger d-block text-left mt-3">
                            <b>* Bedroom is required</b>
                        </small>
                    </div>
                    <!-- Bathrooms Select -->
                    <div class="form-group grid-select" :class="showError && !bathrooms ? 'border-danger' : ''">
                        <select class="form-control selectpicker" v-model="bathrooms">
                            <option value="" :disabled="true">Bathroom</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6+">6+</option>
                        </select>
                        <small v-if="showError && !bathrooms" class="text-danger d-block text-left mt-3">
                            <b>* Bathroom is required</b>
                        </small>
                    </div>

                    <!-- Square footage (Above ground) -->
                    <div class="form-group list-select">
                        <select class="form-control selectpicker" v-model="square_foot">
                            <option value="" :disabled="true">Square footage (Above ground)</option>
                            <option value="500-1000">500-1000</option>
                            <option value="1000-2000">1000-2000</option>
                            <option value="2000-3000">2000-3000</option>
                            <option value="3000-4000">3000-4000</option>
                            <option value="4000+">4000+</option>
                        </select>
                    </div>

                    <!-- Garage -->
                    <div class="form-group grid-select" :class="showError && !garage ? 'border-danger' : ''">
                        <select class="form-control selectpicker" v-model="garage">
                            <option value="" :disabled="true">Garage</option>
                            <option value="0">0</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3+">3+</option>
                            <!-- <option value="4+">4+</option> -->
                        </select>
                        <small v-if="showError && !garage" class="text-danger d-block text-left mt-3">
                            <b>* Garage is required</b>
                        </small>
                    </div>

                    <!-- Basement Type -->
                    <div class="form-group grid-select" :class="showError && !basement ? 'border-danger' : ''">
                        <select class="form-control selectpicker" v-model="basement">
                            <option value="" :disabled="true">Basement Type</option>
                            <option value="Finished">Finished</option>
                            <option value="Unfinished">Unfinished</option>
                        </select>
                        <small v-if="showError && !basement" class="text-danger d-block text-left mt-3">
                            <b>* Basement Type is required</b>
                        </small>
                    </div>

                    <!-- Submit Button -->
                    <div class="text-left text-lg-right submit-btn-wrapper">
                        <button class="button_layout" type="submit" @submit.prevent="submitForm()"
                            :disabled="isButtonLoading">
                            <template v-if="isButtonLoading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Loading...
                            </template>
                            <template v-else> Submit </template>
                        </button>
                    </div>
                </form>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "DirectPropertyValuationStepTwo",
    data() {
        return {
            valuationStep: 7,
            selectedCity: "Toronto",
            selectedAddress: "",
            name: "",
            email: "",
            phone: "",
            propertyType: "",
            basePresent: "Yes",
            bedrooms: "",
            bathrooms: "",
            square_foot: "",
            home_style: "",
            garage: "",
            basement: "",
            utm_source: "RedBuyers",
            utm_medium: "redbuyers.com",
            utm_campaign: "IN_HOUSE",
            utm_id: "REDBUYERS",
            utm_content: "Seventh Step",
            buttonClicked: false,
            valuation_property_unit: "",
            valuation_property_finshed_basement_type: "",
            street_address: "",
            latitude: "",
            longitude: "",
            zip: "",
            isButtonLoading: false,
        };
    },
    computed: {
        formInvalid() {
            if (this.bedrooms && this.bathrooms && this.garage && this.street_address && this.propertyType && this.basement) {
                return false;
            } else {
                return true;
            }
        },
        showError() {
            if (this.formInvalid && this.buttonClicked) {
                return true;
            } else {
                return false;
            }
        },
    },
    watch: {
        bedrooms(value) {
            if (value) {
                sessionStorage.setItem("valuation_bed", value);
            }
        },
        bathrooms(value) {
            if (value) {
                sessionStorage.setItem("valuation_bath", value);
            }
        },
        square_foot(value) {
            if (value) {
                sessionStorage.setItem("valuation_square_foot", value);
            }
        },
        home_style(value) {
            if (value) {
                sessionStorage.setItem("valuation_home_style", value);
            }
        },
        propertyType(value) {
            if (value) {
                sessionStorage.setItem("valuation_property_type", value);
            }
        },
        garage(value) {
            if (value) {
                sessionStorage.setItem("valuation_garage", value);
            }
        },
        basement(value) {
            if (value) {
                sessionStorage.setItem("valuation_property_finshed_basement_type", value);
            }
        },
    },
    mounted() {
        if (sessionStorage.getItem("valuation_city")) {
            this.selectedCity = sessionStorage.getItem("valuation_city");
        }
        if (sessionStorage.getItem("valuation_address")) {
            this.selectedAddress = sessionStorage.getItem("valuation_address");
            this.street_address = this.selectedAddress;
        }
        if (sessionStorage.getItem("valuation_latitude")) {
            this.latitude = sessionStorage.getItem("valuation_latitude");
        }
        if (sessionStorage.getItem("valuation_longitude")) {
            this.longitude = sessionStorage.getItem("valuation_longitude");
        }
        //step-1 data
        if (sessionStorage.getItem("valuation_name")) {
            this.name = sessionStorage.getItem("valuation_name");
        }
        if (sessionStorage.getItem("valuation_email")) {
            this.email = sessionStorage.getItem("valuation_email");
        }
        if (sessionStorage.getItem("valuation_phone")) {
            this.phone = sessionStorage.getItem("valuation_phone");
        }
        //step-2 data
        if (sessionStorage.getItem("valuation_property_type")) {
            this.propertyType = sessionStorage.getItem(
                "valuation_property_type"
            );
        } else {
            sessionStorage.setItem(
                "valuation_property_type",
                this.propertyType
            );
        }
        //step-4 data
        if (sessionStorage.getItem("valuation_basement_present")) {
            this.basePresent = sessionStorage.getItem(
                "valuation_basement_present"
            );
        }
        //step-7 data
        if (sessionStorage.getItem("valuation_bed")) {
            this.bedrooms = sessionStorage.getItem("valuation_bed");
        }
        if (sessionStorage.getItem("valuation_bath")) {
            this.bathrooms = sessionStorage.getItem("valuation_bath");
        }
        if (sessionStorage.getItem("valuation_square_foot")) {
            this.square_foot = sessionStorage.getItem("valuation_square_foot");
        }
        if (sessionStorage.getItem("valuation_home_style")) {
            this.home_style = sessionStorage.getItem("valuation_home_style");
        }
        if (sessionStorage.getItem("valuation_garage")) {
            this.garage = sessionStorage.getItem("valuation_garage");
        }
        //other
        if (sessionStorage.getItem("valuation_utm_source")) {
            this.utm_source = sessionStorage.getItem("valuation_utm_source");
        }
        if (sessionStorage.getItem("valuation_utm_medium")) {
            this.utm_medium = sessionStorage.getItem("valuation_utm_medium");
        }
        if (sessionStorage.getItem("valuation_utm_campaign")) {
            this.utm_campaign = sessionStorage.getItem(
                "valuation_utm_campaign"
            );
        }
        if (sessionStorage.getItem("valuation_utm_id")) {
            this.utm_id = sessionStorage.getItem("valuation_utm_id");
        }
        if (sessionStorage.getItem("valuation_utm_content")) {
            this.utm_content = sessionStorage.getItem("valuation_utm_content");
        }
        if (sessionStorage.getItem("valuation_data")) {
            sessionStorage.removeItem("valuation_data");
        }
        if (
            sessionStorage.getItem("valuation_property_finshed_basement_type")
        ) {
            this.valuation_property_finshed_basement_type = sessionStorage.getItem("valuation_property_finshed_basement_type");
            this.basement = sessionStorage.getItem("valuation_property_finshed_basement_type");
        }
        if (sessionStorage.getItem("valuation_property_unit")) {
            this.valuation_property_unit = sessionStorage.getItem(
                "valuation_property_unit"
            );
        }
    },
    methods: {
        submitForm() {
            this.buttonClicked = true;
            if (!this.formInvalid) {
                this.isButtonLoading = true;
                const formData = new FormData();

                formData.append("utm_id", this.utm_id);
                formData.append("utm_source", this.utm_source);
                formData.append("utm_medium", this.utm_medium);
                formData.append("utm_campaign", this.utm_campaign);
                formData.append("utm_content", this.utm_content);

                formData.append("address", this.selectedAddress);
                formData.append("name", this.name);
                formData.append("email", this.email);
                formData.append("phone", this.phone);

                formData.append("type", this.propertyType);
                formData.append("basement", this.basePresent);

                formData.append("bedrooms", this.bedrooms);
                formData.append("bathrooms", this.bathrooms);
                formData.append("square_foot", this.square_foot);
                formData.append("home_style", this.home_style);
                formData.append("garage", this.garage);
                formData.append(
                    "valuation_property_finshed_basement_type",
                    this.valuation_property_finshed_basement_type
                );
                formData.append(
                    "valuation_property_unit",
                    this.valuation_property_unit
                );

                axios
                    .post("/direct-leads/submit-leads", formData)
                    .then((response) => {
                        //console.log(response.data);
                    })
                    .catch((error) => {
                        console.error(error);
                    })
                    .finally((result) => {
                        sessionStorage.removeItem("valuation_data");
                        // this.$emit("goToNext");
                        // window.location.href =
                        // "/properties/valuation/submit/data/step-9";
                        this.$emit("goTofinal");
                        setTimeout(() => {
                            this.isButtonLoading = false;
                        }, 300);
                    });
            }
        },

        goBack() {
            this.$emit("goToBack");
        },
        getAddressData(addressData, placeResultData, id) {
            console.log({ addressData, placeResultData, id });
            this.latitude = placeResultData.geometry.location.lat();
            this.longitude = placeResultData.geometry.location.lng();
            let streetNumber = placeResultData.address_components.find((el) => el.types[0] == "street_number");
            let streetName = placeResultData.address_components.find((el) => el.types[0] == "route");
            let selectedCity = placeResultData.address_components.find((el) => el.types[0] == "locality");
            if (selectedCity.long_name) {
                this.selectedCity = selectedCity.long_name;
            }

            let zipCode = placeResultData.address_components.find((el) => el.types[0] == "postal_code" || el.types[1] == "postal_code");
            this.zip = zipCode.long_name;

            if (placeResultData?.formatted_address) {
                this.selectedAddress = placeResultData.formatted_address;
                sessionStorage.setItem(
                    "valuation_address",
                    this.selectedAddress
                );
                this.street_address = this.selectedAddress;
            }
            sessionStorage.setItem("valuation_address_short", streetNumber.short_name + ' ' + streetName.short_name);
            sessionStorage.setItem("valuation_city", this.selectedCity);
            sessionStorage.setItem("valuation_latitude", this.latitude);
            sessionStorage.setItem("valuation_longitude", this.longitude);
            sessionStorage.setItem("valuation_zip_code", this.zip);
        },
    },
};
</script>

<style>
    .border-danger>.dropdown.bootstrap-select.form-control.bs3 .btn.dropdown-toggle.btn-default.bs-placeholder {
        border: 1px solid #dc3545 !important;
    }
    .form-control.autocomplete {
        height: 50px;
    }
</style>
